module.exports = __webpack_public_path__ + "img/introResource.1955afdd.png";